import { OptionDescription } from './option.type';
import { ECitizen } from '../enums/citizen.enum';

export type CitizenRecord = Record<ECitizen, OptionDescription<ECitizen>>;
